var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletAdd1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-add-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1751",
    d: "M14.501 15.8756H9.50098",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1752",
    d: "M12.2811 2.24857L12.2511 2.31857L9.35105 9.04857H6.50105C5.84137 9.04841 5.1884 9.18104 4.58105 9.43857L6.33105 5.25857L6.37105 5.15857L6.44105 4.99857C6.45828 4.93958 6.48175 4.88259 6.51105 4.82857C7.82105 1.79857 9.30105 1.10857 12.2811 2.24857Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1753",
    d: "M18.848 9.24857C18.3907 9.11157 17.9153 9.04415 17.438 9.04857H10.527L13.427 2.31857L13.457 2.24857C13.607 2.29857 13.747 2.36857 13.897 2.42857L16.107 3.35857C17.0999 3.69957 17.9954 4.27601 18.717 5.03857C18.8126 5.14958 18.8963 5.27023 18.967 5.39857C19.0557 5.53057 19.1232 5.67566 19.167 5.82857C19.2043 5.91251 19.2344 5.9995 19.257 6.08857C19.4904 7.15749 19.3458 8.27429 18.848 9.24857Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1754",
    d: "M23 14.4696V16.4196C23 16.6196 22.989 16.8196 22.977 17.0196C22.763 20.5076 20.566 22.2696 16.4 22.2696H7.59996C7.33256 22.2682 7.06545 22.2515 6.79996 22.2196C3.21596 22.0096 1.30362 20.3129 1.06296 17.1296C1.02712 16.8946 1.00841 16.6573 1.00696 16.4196V14.4696C1.04115 13.4709 1.37868 12.5063 1.97462 11.7042C2.57057 10.9021 3.39666 10.3006 4.34296 9.97958C5.03529 9.72169 5.76815 9.58961 6.50696 9.58958H17.507C18.043 9.58849 18.5769 9.6557 19.096 9.78958C20.1703 10.0326 21.1348 10.6227 21.8404 11.4685C22.546 12.3144 22.9535 13.369 23 14.4696Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1755",
    d: "M5.71 6.04956L3.96 10.2296C3.0818 10.6074 2.33348 11.2341 1.80745 12.0324C1.28142 12.8307 1.00072 13.7655 1 14.7216V11.7916C0.998851 10.4371 1.46778 9.12431 2.32676 8.07712C3.18574 7.02994 4.38151 6.31331 5.71 6.04956Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1756",
    d: "M22.997 11.8726V14.8046C22.9974 13.758 22.6613 12.739 22.0382 11.8981C21.4152 11.0572 20.5383 10.4389 19.537 10.1346C20.0275 9.15459 20.1754 8.03846 19.957 6.96456C19.9376 6.87458 19.9074 6.78728 19.867 6.70456C20.8115 7.19725 21.6028 7.93961 22.1547 8.85084C22.7066 9.76207 22.9979 10.8072 22.997 11.8726Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd1);
export default __webpack_public_path__ + "static/media/wallet-add-1.650154728defac2073ef1a626a99bdb2.svg";
export { ForwardRef as ReactComponent };